<template>
  <div>
    <div class="columns is-multiline mgb-0" v-if="!tabDestinationChargeTravail">
      <div class="column is-12" v-if="actions && actions.length > 0">
        <selecteur-action
          @handleAction="handleActions"
          :options='actions'
          :placeholder='$t("general.placeHolder.groupedAction")'
          :titleButton="'general.button.apply'"
          :elementsSelectionnes="getAllTourneeFaceSemaineSelected.length > 0">
        </selecteur-action>
      </div>
      <div class="column is-12">
        <div class="level columns is-multiline">
          <div class="column is-9 level-left">
            <div class="columns is-multiline">
              <div class="column is-vcentered is-narrow"
                   v-if="afficherBoutonAffecter || afficherBoutonDesaffecter">
                <button v-if="afficherBoutonAffecter"
                        @click="checkPermissions(permAffectation.maj)
            ? affecter() : showPopUp()"
                        :class="{ 'button-access-no-permission' :
              getAllTourneeFaceSemaineSelected.length === 0
            || !checkPermissions(permAffectation.maj) }"
                        :disabled='getAllTourneeFaceSemaineSelected.length === 0'
                        class="button is-primary mgr-10px">
                  {{ $t('gestionAffectation.actions.affecter') }}
                </button>
                <button v-if="afficherBoutonDesaffecter"
                        @click="checkPermissions(permAffectation.maj)
            ? desaffecter() : showPopUp()"
                        :class="{ 'button-access-no-permission' :
              getAllTourneeFaceSemaineSelected.length === 0
            || !checkPermissions(permAffectation.maj) }"
                        :disabled='getAllTourneeFaceSemaineSelected.length === 0'
                        class="button is-primary">
                  {{ $t('gestionAffectation.actions.desaffecter') }}
                </button>
              </div>
              <form @submit.prevent="recherche()" class="column is-narrow">
                <b-field>
                  <b-input :placeholder="$t('gestionAffectation.actions.search')"
                           type="search"
                           icon="magnify"
                           v-model="critereRecherche.auto">
                  </b-input>
                </b-field>
              </form>
              <div class="column is-3" v-if="afficherDate">
                <b-datepicker :value="getDateValue"
                              @input="changeDateSelect"
                              :disabled="disabledDate"
                              :date-formatter="formatageOuputDatepicker"
                              icon="calendar-today"
                              nearby-selectable-month-days
                              show-week-number
                              :editable="true">
                </b-datepicker>
              </div>
              <div class="column is-narrow mgv-auto" v-if="afficherToggleCommercialisable">
                <qd-switch v-model="filtres.avecNonCommercialisable"
                          @input="recherche()"
                          class="">
                  {{ $t('gestionAffectation.actions.inclureNonCommercialisable') }}
                </qd-switch>
              </div>
            </div>
          </div>
          <div class="level-right row">
            <b-field class="column mg-0">
              <b-checkbox-button
                  v-model="withoutImage"
                  type="is-primary"
                  outlined
                  @input="recherche">
                  <b-icon
                    :icon="withoutImage ? 'image-off-outline' : 'image-outline'"
                    class="mg-0">
                  </b-icon>
              </b-checkbox-button>
            </b-field>
            <div class="column is-narrow">
              <exportExcelButton
                :perm="permAffectation.exporter"
                :query="exportExcelQuery"
                :in-progress="!typeDonnee"/>
            </div>
            <parametrage-table
              :reference-table="referenceTable"
              @endLoadParamtre="startArrayRendering = true">
            </parametrage-table>
          </div>
        </div>
      </div>
    </div>
    <v-server-table url="" :columns="columns" :options="options" :ref="referenceTable"
                    @loaded="finLoading" @loading="debutLoading"
                    v-if="startArrayRendering && mountedLoadingEnd"
                    class="vueTableFilterStyle vueTableTourneeFaceSemaine overflow-x-auto"
                    :class="[
                        {'nonAffecte': estAffecte !== null && estAffecte === 'false' },
                        {'affecte': estAffecte !== null && estAffecte === 'true'},
                      ]">
      <template slot='afterTable'>
        <table-items-in-view :perPage="resultPerPage"
                              @input="$refs[referenceTable].setLimit($event)" />
      </template>
      <div slot="selected" slot-scope="props">
        <b-checkbox v-model="props.row.selected" v-if="!remplacementOT"
                    :value="props.row"
                    :disabled="(!!props.row.ordreTravailId && !tabDestinationChargeTravail)
                      || disabledSelect">
        </b-checkbox>
        <qd-radio v-model="radioSelected" v-else
                  size="is-small"
                  :native-value="props.row.id">
        </qd-radio>
      </div>
      <div slot="restrictionsAffichage"
            slot-scope="props"
            v-if="isRestrictionPage"
            class="is-min-width-500 max-width-500px is-prewrap"
      >
        <p class="has-text-weight-bold">
          {{ props.row.restrictionsAffichage }}
        </p>
      </div>
      <div slot="restrictionsAffichage"
            slot-scope="props"
            v-else
      >
        <b-tooltip :label="props.row.restrictionsAffichage" position="is-left">
          <p class="ellipsis has-text-weight-bold max-width-200-px"
          > {{ props.row.restrictionsAffichage }} </p>
        </b-tooltip>
      </div>
      <div slot="produitReference" slot-scope="props">
        <b-tooltip :label="props.row.produitReference" position="is-right">
          <router-link-blank :to="{ name: 'c.bodac.catalogue-face',
                             params: { id: props.row.produitId}}"
                             :message="props.row.produitReference">
          </router-link-blank>
        </b-tooltip>
      </div>
      <div slot="format" slot-scope="props">
        <b-tooltip :label="props.row.format" position="is-right">
          <p class="ellipsis"> {{ props.row.format }} </p>
        </b-tooltip>
      </div>
      <div slot="tourneeLibelle" slot-scope="props">
        <b-tooltip :label="props.row.tourneeLibelle" position="is-left">
          <p class="ellipsis"> {{ props.row.tourneeLibelle }} </p>
        </b-tooltip>
      </div>
      <div slot="nomAfficheur" slot-scope="props">
        <b-tooltip :label="props.row.nomAfficheur" position="is-left">
          <p class="ellipsis"> {{ props.row.nomAfficheur }} </p>
        </b-tooltip>
      </div>
      <div slot="nomAgence" slot-scope="props">
        <b-tooltip :label="getAgenceLibelle(props.row.agenceId)" position="is-left">
          <p class="ellipsis">
            {{ getAgenceLibelle(props.row.agenceId) }}
          </p>
        </b-tooltip>
      </div>
      <div slot="affichagePrecedent" slot-scope="props">
        <b-tooltip :label="props.row.affichagePrecedent" position="is-right">
          <p class="ellipsis colonneCommentaire"> {{ props.row.affichagePrecedent }} </p>
        </b-tooltip>
      </div>
      <div slot="materiel" slot-scope="props">
        <b-tooltip :label="props.row.materielType" position="is-right">
          <p class="ellipsis"> {{ props.row.materielType }} </p>
        </b-tooltip>
      </div>
      <div slot="materielDisposition" slot-scope="props">
        <b-tooltip :label="props.row.materielDisposition" position="is-right">
          <p class="ellipsis"> {{ props.row.materielDisposition }} </p>
        </b-tooltip>
      </div>
      <div slot="adresse" slot-scope="props">
        <b-tooltip :label="props.row.adresse | adresse" position="is-right">
          <p class="ellipsis"> {{ props.row.adresse | adresse }} </p>
        </b-tooltip>
      </div>
      <div slot="affecter" slot-scope="props">
        <div class="colonneAffecter" :class="[
            {'colonneAffecter-affecter':
              estAffecteeTfs(props.row)},
            {'colonneAffecter-pas-affecter':
              !estAffecteeTfs(props.row)},
            ]"></div>
      </div>
      <div slot="ville" slot-scope="props">
        <b-tooltip :label="props.row.adresse.ville" position="is-right">
          <p class="ellipsis"> {{ props.row.adresse.ville }} </p>
        </b-tooltip>
      </div>
      <div slot="codePostal" slot-scope="props">
        {{ props.row.adresse.codePostal }}
      </div>
      <div slot="affectationLogistiqueLibelle" slot-scope="props">
        <router-link-blank v-if="getAffectationLogistiqueCmdId(props.row)"
                            :to="{
              name: 'c.bodac.commandes',
              params: {
                id: getAffectationLogistiqueCmdId(props.row)
              }
            }"
                            :message="props.row.affectationLogistiqueLigneCommandeLibelle">
        </router-link-blank>
        <span v-else>
            {{ props.row.affectationLogistiqueLigneCommandeLibelle }}
          </span>
      </div>
      <div slot="affectation" slot-scope="props">
        <router-link-blank v-if="props.row.produitsRegroupements.length === 1"
                            :to="{ name: getUrl(props.row),
                  params: {id: props.row.produitsRegroupements[0].produitId}}"
                            :message="props.row.produitsRegroupements[0].libelle">
        </router-link-blank>
        <a class="lien" v-if="props.row.produitsRegroupements.length > 1"
            @click="fillReseauAndFace(props.row)">
          {{ $t('gestionAffectation.tab.multiaffectation' )}}
        </a>
      </div>
      <div slot="affectationLogistiqueProduitLibelle" slot-scope="props">
        <router-link-blank v-if="props.row.affectationLogistiqueProduitId"
                            :to="{ name: getProduitUrl(props.row),
                  params: {id: props.row.affectationLogistiqueProduitId}}"
                            :message="props.row.affectationLogistiqueProduitLibelle">
        </router-link-blank>
      </div>
      <template slot="reseauFaceTags" slot-scope="{ row }">
        <tag-list :listes="getListeTags(row.tags)"/>
      </template>
      <div slot="instructionPose" slot-scope="props">
        {{props.row.instructionPose}}
      </div>
      <div slot="actionLogistique" slot-scope="props">
        {{$t('gestionAffectation.tab.actionLogistiqueValues.'+ props.row.actionLogistique)}}
      </div>
      <div slot="dateDepartCommerciale" slot-scope="props">
        {{ func.formatDate(props.row.dateDepartCommerciale) }}
      </div>
      <div slot="image" slot-scope="props" class="has-text-centered">
        <image-view
          :permission="permAffectation"
          :image="props.row.cheminMin"
          :imageTooltip="props.row.chemin"
          :id="props.row.produitId"
          :libelle="props.row.emplacementCode"
        />
      </div>
      <div slot="commentaire" slot-scope="props">
        <commentaire-list-input
          :id="props.row.id"
          v-model="props.row.commentaire"
          :maj="majCommentaireTfs">
        </commentaire-list-input>
      </div>
      <template #[`filter__reseauFaceTags`]>
        <libelle-tag-input
          v-model="sousReseauxSelected"
          :items="sousReseauTags"
          append-to-body
          field="libelle"
          label=""
          icon=""
          @input="recherche()">
        </libelle-tag-input>
      </template>
      <template #[`filter__format`]>
        <libelle-tag-input
          v-model="formatsFilter"
          :items="formats"
          append-to-body
          field="libelle"
          label=""
          icon=""
          @input="recherche()">
        </libelle-tag-input>
      </template>
    </v-server-table>
    <b-modal v-model="popUpPrevention" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t('gestionAffectation.titlePopUp')"
        :messDescription="$t('gestionAffectation.messDescriptionPopup')"
        :cancel="$t('gestionAffectation.actions.cancel')"
        :validate="$t('gestionAffectation.actions.forcer')"
        @yes="makeAffectation"
        @no="popUpPrevention = false"
      />
    </b-modal>
    <b-modal v-model="popUpInfoCommande" has-modal-card class="modal" :width="500">
      <pop-up-multiaffectation-commande
        @close="removeCommandeAndFace()"
        :commandes="commandesSelect"
        :face="faceSelect">
      </pop-up-multiaffectation-commande>
    </b-modal>
    <b-modal v-model="popUpInfoAffectation" has-modal-card class="modal" :width="500">
      <pop-up-multiaffectation-reseau
        @close="removeReseauAndFace()"
        :produitRegroupement="reseauSelect"
        :face="faceSelect">
      </pop-up-multiaffectation-reseau>
    </b-modal>
    <b-modal v-model="popUpActionAffecterState" has-modal-card class="modal">
      <pop-up-action-affecter
        :actionAffichageDefaut="getDefaultValueOfKey('affectationLogistiqueLigneCommandeLibelle')"
        :tfsSelectionnes="getAllTourneeFaceSemaineSelected"
        :anneeSemaine="anneeSemaine"
        @actionAffichage="setActionAffichage">
      </pop-up-action-affecter>
    </b-modal>
    <b-modal v-model="popUpInstructionPoseState" has-modal-card class="modal">
      <pop-up-instruction-pose
        :instructionPoseDefaut="getDefaultValueOfKey('instructionPose')"
        @instructionPose="setInstructionPose">
      </pop-up-instruction-pose>
    </b-modal>
    <b-modal v-model="popUpAffectationListeAffichageState" has-modal-card class="modal">
      <pop-up-affectation-liste-affichage
        @listeAffichage="setlisteAffichage">
      </pop-up-affectation-liste-affichage>
    </b-modal>
    <b-modal v-model="popUpPreventionLaisserEnPlace" has-modal-card class="modal">
      <pop-up-laisser-en-place
        :laisserEnPlaceState="laisserEnPlaceState"
        :tfsSelectionnes="getAllTourneeFaceSemaineSelected"
        :anneeSemaine="anneeSemaine"
        @apply="setLaisserEnPlace">
      </pop-up-laisser-en-place>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  CATEGORIE_REGROUPEMENT as regroupement,
  CATEGORIE_UNITAIRE as unitaire,
  RESEAU_LC as reseauLc,
  MAIRIE as mairie,
  RESEAU_TEMPO as reseauTempo,
} from '@/configuration/catalogue/produitConf';
import {
  TEXTS, SORT_ICON, NO_PER_PAGE_VALUE, RESULTS_PER_PAGE_200,
} from '@/configuration/clientTableConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { AFFECTATION, ORDRE_TRAVAIL } from '@/configuration/logistique/permissionsLogistiqueConf';
import {
  affecter,
  affecterActionAffichageAsync,
  affecterInstructionPoseAsync,
  updateAffecterTfsToListAffichageAllAsync,
  commenterTfsAsync,
} from '@/api/logistique/tourneeFaceSemaine';
import selecteurAction from '@/components/general/selecteurAction';
import moment from 'moment';
import popUpPrevention from '@/components/general/popUpPrevention';
import formatDate from '@/services/general/formatDate';
import * as tfsConf from '@/configuration/logistique/facesDisponible/facesDisponibleConf';
import popUpActionAffecter from '@/components/logistique/affectation/p_actionAffecter';
import messageErreur from '@/services/general/messageErreur';
import popUpInstructionPose from '@/components/logistique/affectation/p_instructionPose';
import popUpAffectationListeAffichage from '@/components/logistique/affectation/p_affectationListeAffichage';
import popUpLaisserEnPlace from '@/components/logistique/affectation/p_laisserEnPlace';
import serviceEstAffecteeTfs from '@/services/logistique/tourneeFaceSemaine/estAffectee';
import messageSucces from '@/services/general/messageSucces';
import tableItemsInView from '@/components/general/TableItemsInView';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { SET_DATE_SELECT } from '@/store/modules/logistique/demande-mutation-type';
import { REFERENCE_TABLE_TOURNEE_FACE_SEMAINE } from '@/configuration/general/referenceTableConf';
import inProgress from '@/services/general/inProgress';
import { columnsSplice } from '@/services/general/columns';
import parametrageTable from '@/components/general/parametrageTable';
import tagInputToArray from '@/services/general/filters/tagInputToArray';
import imageView from '@/components/general/imageView';
import { SET_DETECT_CHANGE_SOCIETE } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import dateStringToIso from '@/services/general/dateStringToIso';
import commentaireListInput from '@/components/general/input/commentaireListInput/commentaireListInput';
import TagList from '@/components/general/tagList';
import { SOUS_RESEAU } from '@/configuration/parametrage/tagConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import popUpMultiaffectationCommande from './p_multiaffectationCommande';
import popUpMultiaffectationReseau from './p_multiaffectationReseau';

const TourneeFaceSemaine = createNamespacedHelpers('tourneeFaceSemaine');
const Societe = createNamespacedHelpers('societe');
const Permissions = createNamespacedHelpers('permissions');
const Demande = createNamespacedHelpers('demande');
const TableUserParam = createNamespacedHelpers('tableUserParam');
const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    anneeSemaine: {
      type: Number,
      required: true,
    },
    referenceProduitReseau: {
      type: String,
      required: false,
      default: null,
    },
    ligneCommandeId: {
      type: String,
      required: false,
      default: '',
    },
    demandeLogistiqueId: {
      type: String,
      required: false,
      default: '',
    },
    typeDonnee: {
      type: String,
      required: false,
      default: null,
    },
    tabDestinationChargeTravail: {
      type: Boolean,
      required: false,
      default: false,
    },
    tabRestriction: {
      type: Boolean,
      required: false,
      default: false,
    },
    filtres: {
      type: Object,
      required: false,
    },
    mustDisplayOnlyAffecterTfs: {
      type: Boolean,
      required: false,
      default: false,
    },
    mustDisplayOnlyDispoTfs: {
      type: Boolean,
      required: false,
      default: false,
    },
    afficherBoutonAffecter: {
      type: Boolean,
      required: false,
      default: true,
    },
    afficherBoutonDesaffecter: {
      type: Boolean,
      required: false,
      default: true,
    },
    afficherToggleCommercialisable: {
      type: Boolean,
      required: false,
      default: false,
    },
    afficherDate: {
      type: Boolean,
      required: false,
      default: false,
    },
    actions: {
      type: Array,
      required: false,
    },
    disabledSelect: {
      type: Boolean,
      required: false,
      default: false,
    },
    remplacementOT: {
      type: Boolean,
      required: false,
      default: false,
    },
    ajouterFaceOt: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabledDate: {
      type: Boolean,
      required: false,
      default: true,
    },
    isGestionAffectations: {
      type: Boolean,
      required: false,
      default: false,
    },
    referenceTable: {
      type: String,
      required: false,
      default: REFERENCE_TABLE_TOURNEE_FACE_SEMAINE,
    },
  },
  data() {
    return {
      permOrdreTravail: ORDRE_TRAVAIL,
      permAffectation: AFFECTATION,
      popUpPrevention: false,
      popUpInfoCommande: false,
      popUpInfoAffectation: false,
      commandesSelect: [],
      faceSelect: null,
      reseauSelect: [],
      startArrayRendering: false,
      mountedLoadingEnd: false,
      popUpActionAffecterState: false,
      popUpInstructionPoseState: false,
      popUpAffectationListeAffichageState: false,
      popUpPreventionLaisserEnPlace: false,
      laisserEnPlaceState: false,
      constantes: {
        RESULTS_PER_PAGE_200: RESULTS_PER_PAGE_200,
        LAISSER_EN_PLACE_VENTE: tfsConf.LAISSER_EN_PLACE_VENTE,
        SOUS_RESEAU: SOUS_RESEAU,
      },
      radioSelected: null,
      estAffecte: null,
      func: {
        formatDate,
      },
      resultPerPage: RESULTS_PER_PAGE_200,
      withoutImage: true,
      unsubscribeValue: null,
      sousReseauxSelected: [],
      formatsFilter: [],
    };
  },
  filters: {
    adresse(adresse) {
      return adressFullStringGetter(adresse, true);
    },
  },
  components: {
    routerLinkBlank,
    popUpPrevention,
    popUpMultiaffectationCommande,
    popUpMultiaffectationReseau,
    selecteurAction,
    popUpActionAffecter,
    popUpInstructionPose,
    popUpAffectationListeAffichage,
    tableItemsInView,
    popUpLaisserEnPlace,
    exportExcelButton,
    parametrageTable,
    imageView,
    commentaireListInput,
    TagList,
    libelleTagInput,
  },
  watch: {
    anneeSemaine() {
      if (!this.tabDestinationChargeTravail) {
        this.recherche();
      }
    },
  },
  computed: {
    ...TourneeFaceSemaine.mapGetters({
      tourneeFaceSemaine: 'items',
      totalCount: 'total',
      critereRecherche: 'critereRecherche',
      lastPayload: 'lastPayload',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agenceActive: 'agenceActive',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...TableUserParam.mapGetters({
      tableUserParam: 'tableUserParam',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    formats() {
      return this.parametre(PARAMETRES_KEYS.materielFormat)
        .filter(el => el.actif);
    },
    sousReseauTags() {
      return this.parametre(PARAMETRES_KEYS.tag).filter((tag) => {
        return tag.moduleTag === this.constantes.SOUS_RESEAU;
      });
    },
    getAllTourneeFaceSemaineSelected() {
      return this.tourneeFaceSemaine.filter((el) => {
        return el.selected;
      });
    },
    getDateValue() {
      return moment(this.anneeSemaine.toString(), 'GGGGWW').startOf('week').toDate();
    },
    allTourneeFaceSemaineSelected() {
      return this.getAllTourneeFaceSemaineSelected.length === this.tourneeFaceSemaine.length;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          produitReference: this.$t('gestionAffectation.tab.face'),
          format: this.$t('gestionAffectation.tab.format'),
          materiel: this.$t('gestionAffectation.tab.materiel'),
          adresse: this.$t('gestionAffectation.tab.adresse'),
          ville: this.$t('gestionAffectation.tab.ville'),
          codePostal: this.$t('gestionAffectation.tab.codePostal'),
          restrictionsAffichage: this.$t('gestionAffectation.tab.restriction'),
          affectationLogistiqueLibelle: this.$t('gestionAffectation.tab.commande'),
          affichagePrecedent: this.$t('gestionAffectation.tab.campagnePrec'),
          tourneeLibelle: this.$t('gestionAffectation.tab.tourneeLibelle'),
          nomAfficheur: this.$t('gestionAffectation.tab.afficheur'),
          affectation: this.$t('gestionAffectation.tab.affectation'),
          affectationLogistiqueProduitLibelle: this.$t('gestionAffectation.tab.affectationLogistique'),
          reseauFaceTags: this.$t('gestionAffectation.tab.reseauFaceTags'),
          instructionPose: this.$t('gestionAffectation.tab.instructionPose'),
          actionLogistique: this.$t('gestionAffectation.tab.actionLogistique'),
          dateDepartCommerciale: this.$t('gestionAffectation.tab.dateDepartCommerciale'),
          materielDisposition: this.$t('gestionAffectation.tab.materielDisposition'),
          nomAgence: this.$t('gestionAffectation.tab.nomAgence'),
          commentaire: this.$t('gestionAffectation.tab.commentaire'),
          affecter: '',
          actions: '',
          selected: (h) => {
            if (this.remplacementOT || this.ajouterFaceOt) return null;
            return h(
              'a',
              {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: this.filterableColumn,
        filterByColumn: true,
        listColumns: {
          affecter: [
            {
              id: true,
              text: this.$i18n.t('gestionAffectation.affecter'),
            },
            {
              id: false,
              text: this.$i18n.t('gestionAffectation.nonAffecter'),
              hide: this.mustDisplayOnlyAffecterTfs,
            },
          ],
          actionLogistique: [
            {
              id: [tfsConf.AUCUN],
              text: this.$i18n.t('gestionAffectation.aucun'),
            },
            {
              id: [tfsConf.LAISSER_EN_PLACE_VENTE, tfsConf.LAISSER_EN_PLACE],
              text: this.$i18n.t('gestionAffectation.laisserEnPlace'),
            },
            {
              id: [tfsConf.MANUEL, tfsConf.AFFICHAGE],
              text: this.$i18n.t('gestionAffectation.affichage'),
            },
          ],
          nomAgence: [
            ...this.agenceActive.map(agence => ({
              id: agence.libelleAgence,
              text: agence.libelleAgence,
            })),
          ],
        },
        initFilters: {
          affecter: this.initFiltreAffecter,
          ville: this.initFiltreVille,
          nomAgence: 'null',
        },
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((dataFromServer) => {
          const data = cloneDeep(dataFromServer);
          data.withoutImage = this.withoutImage;
          data.query.societeId = this.societeActiveId;
          data.query.tagIds = tagInputToArray(this.sousReseauxSelected, 'id');
          data.query.formatIds = tagInputToArray(this.formatsFilter, 'id');
          const agences = this.agenceActive.find(
            (agence) => agence.libelleAgence === dataFromServer.query.nomAgence);
          data.query.agencesIds = agences !== undefined
            ? [agences.agenceId] : this.agenceActive.map((agence) => agence.agenceId);
          if (this.critereRecherche.typeProduits) {
            data.query.typeProduits = this.critereRecherche.typeProduits;
          }
          data.query.auto = this.critereRecherche.auto;
          if (!this.critereRecherche.avecLaisserEnPlaceVente) {
            data.query.avecLaisserEnPlaceVente = this.critereRecherche.avecLaisserEnPlaceVente;
          }
          if (data.query.dateDepartCommerciale) {
            data.query.dateDepartCommerciale = dateStringToIso(data.query.dateDepartCommerciale);
          }
          if (this.critereRecherche.afficheurIds) {
            data.query.afficheurIds = this.critereRecherche.afficheurIds;
          }
          if (this.critereRecherche.sansTournee !== undefined) {
            data.query.sansTournee = this.critereRecherche.sansTournee;
          }
          if (this.critereRecherche.sansAfficheur !== undefined) {
            data.query.sansAfficheur = this.critereRecherche.sansAfficheur;
          }
          if (this.critereRecherche.tourneeId !== undefined) {
            data.query.tourneeId = this.critereRecherche.tourneeId;
          }
          data.query.anneeSemaine = this.anneeSemaine;
          if (this.tabDestinationChargeTravail) {
            data.query.avecActionLogistique = true;
            data.query.avecNonCommercialisable = true;
          }
          if (this.mustDisplayOnlyAffecterTfs) data.query.affecter = true;
          if (!this.filtres) {
            return this.actionLoadTourneeFaceSemaine(data);
          }
          if (this.filtres.estAffecteReseau) {
            data.query.reseauId = this.referenceProduitReseau;
          } else {
            data.query.reseauId = null;
          }
          if (this.filtres.estAffecteLigneCommande) {
            data.query.affectationLogistique = this.ligneCommandeId;
          } else {
            data.query.affectationLogistique = null;
          }
          if (this.filtres.estAffecteDemande) {
            if (this.demandeLogistiqueId) {
              data.query.demandeLogistiqueIds = [this.demandeLogistiqueId];
            }
          } else {
            data.query.demandeLogistiqueIds = [];
          }
          if (this.filtres.hasRestrictionAffichage !== null
            && this.filtres.hasRestrictionAffichage !== undefined) {
            data.query.hasRestrictionAffichage = this.filtres.hasRestrictionAffichage;
          }
          if (this.filtres.avecNonCommercialisable) {
            data.query.avecNonCommercialisable = this.filtres.avecNonCommercialisable;
          }
          if (this.filtres.notInOtId) {
            data.query.notInOtId = this.filtres.notInOtId;
          }
          if (this.filtres.otId) {
            data.query.otId = this.filtres.otId;
          }
          this.estAffecte = data.query.affecter + '';
          return this.actionLoadTourneeFaceSemaine(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.tourneeFaceSemaine,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          selected: 'colonneSelected',
          affecter: 'colonneSelected',
          actions: 'colonneSelected',
          nomAgence: 'colonneSelected',
          affectationLogistiqueLibelle: 'colonneCommentaire',
        },
        sortable: ['actionLogistique', 'affectationLogistiqueLibelle', 'affichagePrecedent', 'instructionPose', 'restrictionsAffichage', 'affectationLogistiqueProduitLibelle', 'produitReference', 'format', 'materiel', 'materielDisposition', 'adresse', 'codePostal', 'ville', 'tourneeLibelle', 'nomAfficheur', 'affectation', 'dateDepartCommerciale'],
      };
    },
    iconSelectTotal() {
      if (this.allTourneeFaceSemaineSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    columns() {
      let tab = ['selected', 'image', 'affecter', 'actionLogistique', 'affectationLogistiqueLibelle', 'affichagePrecedent', 'commentaire', 'affectationLogistiqueProduitLibelle', 'produitReference', 'nomAgence', 'affectation', 'format', 'materiel', 'materielDisposition', 'adresse', 'codePostal', 'ville', 'reseauFaceTags', 'instructionPose', 'restrictionsAffichage', 'tourneeLibelle', 'nomAfficheur'];
      if (this.tabRestriction) {
        tab = ['selected', 'image', 'affecter', 'actionLogistique', 'affectationLogistiqueLibelle', 'restrictionsAffichage', 'affichagePrecedent', 'commentaire', 'affectationLogistiqueProduitLibelle', 'produitReference', 'nomAgence', 'affectation', 'format', 'materiel', 'materielDisposition', 'adresse', 'codePostal', 'ville', 'reseauFaceTags', 'instructionPose', 'tourneeLibelle', 'nomAfficheur'];
      }
      if (this.tabDestinationChargeTravail) {
        tab = ['selected', 'image', 'actionLogistique', 'dateDepartCommerciale', 'affectationLogistiqueLibelle', 'restrictionsAffichage', 'affichagePrecedent', 'commentaire', 'affectationLogistiqueProduitLibelle', 'produitReference', 'nomAgence', 'affectation', 'tourneeLibelle', 'format', 'materiel', 'materielDisposition', 'adresse', 'codePostal', 'ville', 'reseauFaceTags', 'instructionPose'];
      }
      if (this.remplacementOT || this.ajouterFaceOt) {
        tab = ['selected', 'image', 'affecter', 'actionLogistique', 'produitReference', 'nomAgence', 'affectation', 'format', 'materiel', 'materielDisposition', 'adresse', 'codePostal', 'ville', 'reseauFaceTags', 'instructionPose', 'restrictionsAffichage', 'tourneeLibelle', 'nomAfficheur', 'affectationLogistiqueLibelle', 'affichagePrecedent', 'commentaire', 'affectationLogistiqueProduitLibelle'];
      }
      if (this.isGestionAffectations) {
        tab = ['selected', 'image', 'affecter', 'actionLogistique', 'affectationLogistiqueLibelle', 'affichagePrecedent', 'restrictionsAffichage', 'commentaire', 'affectationLogistiqueProduitLibelle', 'produitReference', 'nomAgence', 'affectation', 'format', 'materiel', 'materielDisposition', 'adresse', 'codePostal', 'ville', 'reseauFaceTags', 'instructionPose', 'tourneeLibelle', 'nomAfficheur'];
      }
      if (this.agenceActive.length === 1) columnsSplice(tab, 'nomAgence');
      if (this.withoutImage) columnsSplice(tab, 'image');
      return tab;
    },
    filterableColumn() {
      const column = ['produitReference', 'materiel', 'instructionPose', 'restrictionsAffichage', 'materielDisposition', 'adresse', 'codePostal', 'ville', 'commentaire', 'affectationLogistiqueProduitLibelle', 'affichagePrecedent', 'affectation', 'affectationLogistiqueLibelle', 'actionLogistique', 'tourneeLibelle'];
      if (!this.tabDestinationChargeTravail) {
        column.push('affecter');
        column.push('nomAfficheur');
      }
      if (this.tabDestinationChargeTravail) {
        column.push('dateDepartCommerciale');
      }
      if (this.agenceActive.length > 1) column.push('nomAgence');
      if (this.mustDisplayOnlyAffecterTfs) column.splice(0, 1);
      return column;
    },
    initFiltreAffecter() {
      if (this.mustDisplayOnlyAffecterTfs) return 'true';
      if (this.mustDisplayOnlyDispoTfs) return 'false';
      return 'null';
    },
    initFiltreVille() {
      return this.filtres && this.filtres.ville ? this.filtres.ville : '';
    },

    isRestrictionPage() {
      return (this.$route.name === 'l.logistique.demande-restriction');
    },
    exportExcelQuery() {
      return {
        typeDonnee: this.typeDonnee,
        typeExport: null,
        filtres: this.lastPayload,
      };
    },
  },
  methods: {
    ...TourneeFaceSemaine.mapActions({
      actionLoadTourneeFaceSemaine: 'loadTourneeFaceSemaine',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Demande.mapMutations({
      setDateSelect: SET_DATE_SELECT,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    estAffecteeTfs(tfs) {
      return serviceEstAffecteeTfs(tfs);
    },
    getAffectationLogistiqueCmdId(tfs) {
      if (!tfs.affectationLogistiqueLigneCommandeId) return null;
      const commande = tfs.commandes.find(cmd => {
        return cmd.ligneCommandeId === tfs.affectationLogistiqueLigneCommandeId;
      });
      if (commande) return commande.commandeId;
      return null;
    },
    getDefaultValueOfKey(key) {
      const tfsSelected = this.getAllTourneeFaceSemaineSelected;
      return [...new Set(tfsSelected.map((tfs) => tfs[key]))].length === 1
        ? tfsSelected[0][key]
        : null;
    },
    handleActions(action) {
      this.errorLaisserEnPlace = false;
      this.msgErrorLaisserEnPlace = [];
      switch (action) {
        case tfsConf.ACTION_AFFICHAGE:
          this.popUpActionAffecterState = true;
          break;
        case tfsConf.ACTION_INSTRUCTION_POSE:
          this.popUpInstructionPoseState = true;
          break;
        case tfsConf.ACTION_LAISSER_EN_PLACE:
          this.laisserEnPlaceState = true;
          this.popUpPreventionLaisserEnPlace = true;
          break;
        case tfsConf.ACTION_ENLEVER_LAISSER_EN_PLACE:
          this.laisserEnPlaceState = false;
          this.popUpPreventionLaisserEnPlace = true;
          break;
        case tfsConf.ACTION_AFFECTER_LISTE_AFFICHAGE:
          this.popUpAffectationListeAffichageState = true;
          break;
        default:
          break;
      }
    },
    setLaisserEnPlace() {
      this.popUpPreventionLaisserEnPlace = false;
      this.recherche();
    },
    async setActionAffichage(actionAffichage, tfsSelectionnes) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await affecterActionAffichageAsync({
          actionAffichage: actionAffichage,
          ids: tfsSelectionnes.map((tfs) => { return tfs.id; }),
        });
        this.popUpActionAffecterState = false;
        messageSucces(this.$i18n.t('gestionAffectation.popUpActionAffecter.success'));
        this.recherche();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async setInstructionPose(instructionPose) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await affecterInstructionPoseAsync({
          instructionPose: instructionPose,
          ids: this.getAllTourneeFaceSemaineSelected.map((tfs) => { return tfs.id; }),
        });
        this.popUpInstructionPoseState = false;
        messageSucces(this.$i18n.t('gestionAffectation.popUpInstructionPose.success'));
        this.recherche();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async setlisteAffichage(laId) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await updateAffecterTfsToListAffichageAllAsync({
          listeAffichageId: laId,
          tourneeFaceSemaineIds: this.getAllTourneeFaceSemaineSelected
            .map(tfs => tfs.id),
        });
        this.popUpAffectationListeAffichageState = false;
        messageSucces(this.$i18n.t('gestionAffectation.popUpAffectationListeAffichage.success'));
        this.recherche();
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    getProduitUrl(tfs) {
      if (tfs.affectationLogistiqueProduit.supportCommercial.categorieVente === regroupement) {
        return 'c.bodac.catalogue-reseau';
      }
      if (tfs.affectationLogistiqueProduit.supportCommercial.categorieVente === unitaire) {
        return 'c.bodac.catalogue-face';
      }
      return '';
    },
    getUrl(tfs) {
      if (tfs.produitsRegroupements[0].categorieReseau === reseauTempo) {
        return 'c.bodac.catalogue-reseau';
      }
      if (tfs.produitsRegroupements[0].categorieReseau === reseauLc) {
        return 'c.bodac.catalogue-reseauLc';
      }
      if (tfs.produitsRegroupements[0].categorieReseau === mairie) {
        return 'c.bodac.catalogue-reseauMairie';
      }
      return '';
    },
    getListeTags(tags) {
      const tagIds = tags?.map(t => t.tagId) ?? [];
      return this.sousReseauTags.filter(rst => tagIds.includes(rst.id));
    },
    formatageOuputDatepicker() {
      const semaine = Number(this.anneeSemaine.toString().substr(4));
      const dateDebut = moment(this.anneeSemaine, 'GGGGWW').startOf('week').toDate();
      const dateFin = moment(this.anneeSemaine, 'GGGGWW').endOf('week').toDate();
      return 'S' + semaine + ' : ' + formatDate(dateDebut) + ' - ' + formatDate(dateFin);
    },
    fillCommandeAndFace(row) {
      this.commandesSelect = row.commandes;
      this.faceSelect = row.produitReference;
      this.popUpInfoCommande = true;
    },
    removeCommandeAndFace() {
      this.popUpInfoCommande = false;
      this.commandesSelect = [];
      this.faceSelect = null;
    },
    fillReseauAndFace(row) {
      this.reseauSelect = row.produitsRegroupements;
      this.faceSelect = row.produitReference;
      this.popUpInfoAffectation = true;
    },
    removeReseauAndFace() {
      this.popUpInfoAffectation = false;
      this.reseauSelect = [];
      this.faceSelect = null;
    },
    async makeAffectation() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.popUpPrevention = false;
        const tourneeFaceSemaineIds = this.getAllTourneeFaceSemaineSelected.map((
          tourneeFaceSemaine => {
            return tourneeFaceSemaine.id;
          }));
        if (this.ligneCommandeId) {
          await affecter({
            tourneeFaceSemaineIds: tourneeFaceSemaineIds,
            ligneCommandeId: this.ligneCommandeId,
          });
        } else if (this.demandeLogistiqueId) {
          await affecter({
            tourneeFaceSemaineIds: tourneeFaceSemaineIds,
            demandeLogistiqueId: this.demandeLogistiqueId,
          });
        }
        this.$emit('reloadAffectationReseauWithFilter', false);
        loadingComponent.close();
        messageSucces(this.$t('gestionAffectation.success.affectation'));
        this.recherche();
        this.getAllTourneeFaceSemaineSelected.forEach((tourneeFaceSemaine) => {
          tourneeFaceSemaine.selected = false;
        });
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw (e);
      }
    },
    affecter() {
      if (this.getAllTourneeFaceSemaineSelected.find((tourneeFaceSemaine) => {
        return tourneeFaceSemaine.affectationLogistiqueLigneCommandeId;
      })) {
        this.popUpPrevention = true;
      } else this.makeAffectation();
    },
    async desaffecter() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.popUpPrevention = false;
        await affecter({
          tourneeFaceSemaineIds: this.getAllTourneeFaceSemaineSelected.map((
            tourneeFaceSemaine => {
              return tourneeFaceSemaine.id;
            })),
          ligneCommandeId: null,
          demandeLogistiqueId: null,
        });
        this.$emit('reloadAffectationReseauWithFilter', true);
        loadingComponent.close();
        messageSucces(this.$t('gestionAffectation.success.desaffectation'));
        this.recherche();
        this.getAllTourneeFaceSemaineSelected.forEach((tourneeFaceSemaine) => {
          tourneeFaceSemaine.selected = false;
        });
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw (e);
      }
    },
    selectAll() {
      if (this.disabledSelect) return;
      const select = !this.allTourneeFaceSemaineSelected;
      if (this.tabDestinationChargeTravail) {
        this.tourneeFaceSemaine
          .forEach((el) => {
            el.selected = select;
          });
      } else {
        this.tourneeFaceSemaine
          .filter((tfs) => {
            return !tfs.ordreTravailId;
          })
          .forEach((el) => {
            el.selected = select;
          });
      }
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    initFilters(affecter) {
      this.$refs[this.referenceTable].setFilter({
        affecter: affecter + '',
      });
    },
    changeDateSelect(date) {
      if (!date) return;
      this.setDateSelect(date);
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    getAgenceLibelle(agenceId) {
      const agence = this.agenceActive.find((agence) => agence.agenceId === agenceId);
      if (agence === undefined) return '';
      return agence.libelleAgence;
    },
    majCommentaireTfs(id, commentaire) {
      commenterTfsAsync({
        id: id,
        commentaire: commentaire,
      });
    },
  },
  async mounted() {
    this.estAffecte = this.initFiltreAffecter;
    this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, undefined, this.recherche);
    await this.loadParametres([PARAMETRES_KEYS.materielFormat, PARAMETRES_KEYS.tag]);
    if (this.mustDisplayOnlyAffecterTfs) {
      this.critereRecherche.avecActionLogistique = 'true';
    }

    if (this.mustDisplayOnlyDispoTfs) {
      this.critereRecherche.affecter = 'false';
    }

    this.resultPerPage = this.tableUserParam[this.referenceTable]?.nbResultatParPage
      || this.constantes.RESULTS_PER_PAGE_200;
    this.mountedLoadingEnd = true;
    if (this.tabDestinationChargeTravail) this.startArrayRendering = true;
  },
  beforeDestroy() {
    this.unsubscribeValue();
  },
};
</script>
